import { MissionsTypes, MissionsAction, Mission, Skill, Stage } from '../types';

export function getList(missions: Mission[]): MissionsAction<{ missions: Mission[] }> {
    return {
        type: MissionsTypes.GET_LIST,
        payload: { missions },
    };
}

export function requestGetMissionsList() {
    return {
        type: MissionsTypes.REQUEST_GET_LIST,
    };
}
export function saveMission(mission?: Mission): MissionsAction<{ mission?: Mission }> {
    return {
        type: MissionsTypes.SAVE_MISSION,
        payload: { mission },
    };
}

export function requestSaveMission(
    mission: Mission,
    skills: Skill[],
    isNewMission: boolean,
    isSomeSurveyExit: boolean,
): MissionsAction<{
    mission: Mission;
    skills: Skill[];
    isNewMission: boolean;
    isSomeSurveyExit: boolean;
}> {
    return {
        type: MissionsTypes.REQUEST_SAVE_MISSION,
        payload: { mission, skills, isNewMission, isSomeSurveyExit },
    };
}

export function saveStage(missionId: string, stage?: Stage): MissionsAction<{ missionId: string; stage?: Stage }> {
    return {
        type: MissionsTypes.SAVE_STAGE,
        payload: { missionId, stage },
    };
}

export function requestSaveStage(stage: Stage, missionId: string): MissionsAction<{ stage: Stage; missionId: string }> {
    return {
        type: MissionsTypes.REQUEST_SAVE_STAGE,
        payload: { stage, missionId },
    };
}

export function updateRewards(
    missionId: string,
    rewards?: string[],
): MissionsAction<{ missionId: string; rewards?: string[] }> {
    return {
        type: MissionsTypes.UPDATE_REWARDS,
        payload: { missionId, rewards },
    };
}

export function requestUpdateRewards(
    rewards: string[],
    missionId: string,
): MissionsAction<{ rewards: string[]; missionId: string }> {
    return {
        type: MissionsTypes.REQUEST_UPDATE_REWARDS,
        payload: { rewards, missionId },
    };
}
